import {createFileRoute} from '@tanstack/react-router';
import {CollectionsPage} from '@/features/collections';

interface CollectionsListSearchSchema {
  page?: number;
}

export const Route = createFileRoute('/_app/collections/')({
  validateSearch: (search: CollectionsListSearchSchema) => {
    return search;
  },
  beforeLoad: () => ({
    getTitle: () => 'Коллекции',
  }),
  component: () => <CollectionsPage />,
});
